import React, { createContext, useContext, useState } from "react";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const raw = localStorage.getItem("samrudhi_admin_info");
    return raw ? JSON.parse(raw) : null;
  });

  const login = (token, adminInfo) => {
    localStorage.setItem("samrudhi_admin_token", token);
    localStorage.setItem("samrudhi_admin_info", JSON.stringify(adminInfo));
    setAdmin(adminInfo);
  };

  const logout = () => {
    localStorage.removeItem("samrudhi_admin_token");
    localStorage.removeItem("samrudhi_admin_info");
    setAdmin(null);
  };

  const updateAdmin = (adminInfo) => {
    localStorage.setItem("samrudhi_admin_info", JSON.stringify(adminInfo));
    setAdmin(adminInfo);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, updateAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
